export default __webpack_public_path__ + "static/media/Snd_G_Starts.177ba920.mp3";